export const paginateTable = (table: any, fetch?: number) => {
	table.fetch = fetch;
	table.rows.splice(fetch);
	return table;
};
